"use client";

import ModalBody from "@/app/_components/ModalBody";
import ModalOverlay from "@/app/_components/ModalOverlay";
import {useUserInfo} from "@/app/_components/contexts/userInfoContext";
import {useEffect, useState} from "react";
import {Dialog, Modal} from "react-aria-components";
import NonAcademyUserModalBody from "./UnknownUserModalBody";
import {isUnknownUserType} from "@/app/util/userUtils";

const UnknownUserDialog = () => {
	const {userInfo, isLoading} = useUserInfo();
	const [isOpen, setIsOpen] = useState(false);
	useEffect(() => {
		if (isUnknownUserType(userInfo)) {
			setIsOpen(true);
		}
	}, [userInfo]);
	if (!isOpen || !userInfo) {
		return null;
	}
	return (
		<ModalOverlay
			isDismissable={false}
			isOpen={isOpen && !isLoading}
			onOpenChange={setIsOpen}
		>
			<Modal>
				<Dialog>
					<ModalBody
						hasCloseButton={false}
						onClose={() => setIsOpen(false)}
						className="h-full w-svw max-w-screen-md rounded-xl py-0"
					>
						<NonAcademyUserModalBody
							userInfo={userInfo}
							closeModal={() => setIsOpen(false)}
						/>
					</ModalBody>
				</Dialog>
			</Modal>
		</ModalOverlay>
	);
};

export default UnknownUserDialog;
